import qs from 'qs';

const queryParams = (params: Record<string, string | undefined>) => qs.stringify(params);
export const createPath = (part: string | number, params?: Record<string, string | undefined>) => {
  const baseUrl = import.meta.env.VITE_API_HOST;
  const path = `/v4/admin/access/${part}`;
  const url = new URL(path, baseUrl);
  if (params) {
    url.search = queryParams(params);
  }
  return String(url);
};
